<template>
  <div>
    <template>
      <h2 class="title">
        {{ product.payload.product }}
        <font-awesome-icon
          class="text-primary"
          :icon="['far', 'arrow-alt-circle-down']"
          :style="iconStyle"
        ></font-awesome-icon>
      </h2>
      <p class="message">
        {{
          $t(
            `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['PRICE-REDUCTION']}.priceReductionMessage`,
            {
              reducedPrice: $n(
                product.payload.data.currentPrice,
                'currencyDollars',
                getLanguageCodeForNumericalInternationalization
              ),
              savings: $n(
                product.payload.data.savings,
                'currencyDollars',
                getLanguageCodeForNumericalInternationalization
              ),
            }
          )
        }}
      </p>
      <div class="row">
        <div class="col left">
          <p class="price-header">
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['PRICE-REDUCTION']}.currentPrice`
              )
            }}
          </p>
          <p class="price">
            {{
              $n(product.payload.data.currentPrice, 'currencyDollars', getLanguageCodeForNumericalInternationalization)
            }}
          </p>
        </div>
        <div class="col right">
          <p class="price-header">
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['PRICE-REDUCTION']}.originalPrice`
              )
            }}
          </p>
          <p class="price">
            {{
              $n(product.payload.data.originalPrice, 'currencyDollars', getLanguageCodeForNumericalInternationalization)
            }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RecentPriceDrop',
  computed: {
    ...mapGetters('user', ['getLanguageCodeForNumericalInternationalization']),
  },
  data() {
    return {
      iconStyle: {
        fontSize: '21px',
      },
    };
  },
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';

.message {
  padding-bottom: 25px;
}

.left {
  background-color: $primary-light-background2;
  border-left: 4px solid $primary;
  text-transform: uppercase;
  height: 75px;
}

.right {
  background-color: #f0f4f7;
  border-left: 4px solid #b3c0cb;
  text-transform: uppercase;
  height: 75px;
}

.row {
  column-gap: 24px;
  margin-left: auto;
  margin-right: auto;
}

.price-header {
  color: black;
  font-size: 14px;
}

.price {
  font-size: 20px;
  font-weight: bold;
  color: black;
  vertical-align: middle;
  padding-bottom: 20px;
  position: relative;
  bottom: 12px;
}
</style>
